export const DONATION_ROOT = "/donation";
export const PUBLIC_ADS = "/ads/public/get";
export const DONATE_INSERT = "/ads/public/donate/insert";